import { rtkapi } from './rtkapi';

const searchapi = rtkapi.enhanceEndpoints({ addTagTypes: ['search'] }).injectEndpoints({
    endpoints: (build) => ({
        getsearch: build.query({
            query: (params) => ({ url: '/search-image/', params }),
            providesTags: ['search']
        }),
        getSearchExtractDate: build.query({
            query: (params) => ({ url: '/search-extraction-dates/', params })
        }),
        getAdvancedSearchParameters: build.query({
            query: (params) => ({ url: '/search-image/parameters/', params }),
            providesTags: ['search']
        }),
        getAdvancedSearch: build.query({
            query: (params) => ({ url: '/search-image/advanced/', params }),
            providesTags: ['search']
        }),
        searchBoms: build.query({
            query: (searchQuery) => ({ url: '/boms/search/', params: { q: searchQuery } }),
        }),
    })
});

export const { useGetsearchQuery, useGetSearchExtractDateQuery, useGetAdvancedSearchParametersQuery, useGetAdvancedSearchQuery, useSearchBomsQuery } = searchapi;